import api from "api";
import { getCurrentUserRole } from "modules/utilities/utility";
const curentUserRole = await getCurrentUserRole();
export function fetchUser(role) {
  if (["admin", "super_admin", 'team_lead'].includes(curentUserRole)) {
    return api.get(`/users`);
  } else {
    return api.get(`v2/users?userRole=${role}`);
  }
}
export function setStatus(status, id) {
  return api.put(`user/${id}/toggleActiveStatus?status=${status}`);
}

export function createNewUser(userInfo) {
  return api.post(`role_user`, userInfo);
}

export const getRoles = () => {
  return api.get(`roles`);
};
export const getAuditLog = (userId) => {
  return api.get(`user-audit-logs/${userId}`);
};

export const setActivityLog = async (userId, payload) => {
  return api.post(`auditLog/${userId}`, payload);
};

export const getFreshworkDetails = (userId) => {
  return api.get(`getFreshworkDetails/${userId}`);
};

// export const deactivateUser = (userId, payload) => {
//   return api.put(`user/${userId}/deactivate`, payload);
// };

export const updateUser = (userid, payload) => {
  let apiUrl = `user/${userid}/edit`;
  return api.put(apiUrl, payload);
};

export const getUserSearch = (searchQuery, currentUser) => {
  return api.get(
    `searchUser?searchQuery=${searchQuery}&userRole=${currentUser}`
  );
};

export const editUser = (userid, payload) => {
  return api.put(`user/${userid}/edit`, payload);
};

export const getLoginReport = (startDate, endDate) => {
  const selectedDate = `${startDate},${endDate}`;
  return api.get(`loginReport?selectedDate=${selectedDate}`);
};
export const getAssingedCases = (id) => {
  return api.get(`user/${id}/assignedCases`);
};

export const deactivateUser = (id) => {
  return api.put(`v2/user/${id}/deactivate`);
};

export const reallocateUser = (id) => {
  return api.put(`user/${id}/onboard-allocation`);
};

export const activateUser = (id) => {
  return api.put(`v2/user/${id}/activate`);
};

export function fetchUserV1() {
  return api.get(`ssot/internalUserDetail`);
}

export function editSSOT(paylaod) {
  return api.post(`ssot-user-edit`, paylaod);
}

export function getSSOTFilter() {
  return api.get(`/ssot/filters`);
}

export function getSSOTFilterApply(queryParams) {
  return api.get(`/ssot/internalUserDetail` + queryParams);
}

export function getQaAgents() {
  return api.get('/v1/qaIntegration/getAllQaAgents');
}

export function getCallProvider() {
  return api.get("callProviders");
}

export function getUsersCallProvider(query) {
  let URL = "userCallProviders";
  if (query) URL += `?${query}`;
  return api.get(URL);
}

export function updateUserCallProvider(userCallProviderId, payload = {}) {
  return api.put(`userCallProvider/${userCallProviderId}`, payload);
}

export function createUserCallProvider(payload = {}) {
  return api.post(`userCallProvider/create`, payload);
}

export function createCallProvider(payload = {}) {
  return api.post(`callProvider/create`, payload);
}

export function updateCallProvider(providerId, payload = {}) {
  return api.put(`callProvider/${providerId}`, payload);
}